import { IconNames } from '@blueprintjs/icons';
import { Icon } from '@strata/react-status-icons';
import classNames from 'classnames';
import { type ComponentProps } from 'react';

import { Determination, PriorAuthStatusMessages, TransactionType } from 'services/constants';
import { type EPaResponse } from 'store/api/epaApi';

interface PriorAuthStatusProps extends Pick<ComponentProps<typeof Icon>, 'className'> {
    response?: EPaResponse;
    // determination: (typeof Determination)[keyof typeof Determination];
}

const STATUS_MAP = {
    [Determination.DENIED]: { icon: IconNames.DISABLE, intent: Icon.Intent.ERROR },
    [Determination.APPROVED]: { icon: IconNames.TICK_CIRCLE, intent: Icon.Intent.SUCCESS },
    [Determination.OPEN]: { icon: IconNames.HELP, intent: Icon.Intent.WARNING },
    [Determination.CLOSED]: { icon: IconNames.CROSS, intent: Icon.Intent.INVERSE },
    [TransactionType.PA_CANCEL_RESPONSE]: { icon: IconNames.BLANK, intent: Icon.Intent.INVERSE },
} as const;

const mapResponseToPriorAuthStatus = (response: EPaResponse | undefined) => {
    if (!response) {
        return undefined;
    }
    if (response.transactionType === TransactionType.PA_CANCEL_RESPONSE) {
        return STATUS_MAP[TransactionType.PA_CANCEL_RESPONSE];
    }
    return STATUS_MAP[response.determination as keyof typeof STATUS_MAP];
};

const getStatusText = (response: EPaResponse | undefined) => {
    if (!response) {
        return undefined;
    }
    if (response.transactionType === TransactionType.PA_CANCEL_RESPONSE) {
        return PriorAuthStatusMessages[TransactionType.PA_CANCEL_RESPONSE];
    }
    return response.determination;
};

export const PriorAuthStatus = ({ response = undefined, className }: PriorAuthStatusProps) => {
    const statusIcon = mapResponseToPriorAuthStatus(response);
    const { icon, intent } = statusIcon ?? {
        icon: undefined,
        intent: undefined,
    };
    const statusText = getStatusText(response);

    const hasStatusIcon =
        response?.determination === Determination.DENIED ||
        response?.determination === Determination.APPROVED;
    const isCancelResponse = response?.transactionType === TransactionType.PA_CANCEL_RESPONSE;

    return (
        <span className={classNames('flex__gap--x-small', className)}>
            {hasStatusIcon && !isCancelResponse && <Icon icon={icon} intent={intent} />}
            <span className="sds_value sds_value--detail">{statusText}</span>
        </span>
    );
};
